const withUnit = (value) => {
    if (typeof value === 'undefined')
        return;
    if (typeof value === 'number')
        return `${value}px`;
    return value;
};

export { withUnit };
//# sourceMappingURL=withUnit.js.map
